'use strict';

var React = require('react');
var Dom = require('react-dom');
var assetsHelper = require('../../helper/assetsHelper');
var GlobalConst = require('../../types/GlobalConst');

var VerticalScrollBar = React.createClass({
  propTypes: {
    value: React.PropTypes.number.isRequired,
    left: React.PropTypes.number,
    top: React.PropTypes.number,
    right: React.PropTypes.number,
    bottom: React.PropTypes.number,
    width: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    height: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    backgroundColor: React.PropTypes.string,
    zIndex: React.PropTypes.number
  },

  componentDidUpdate: function () {
    this.repaint();
  },

  componentDidMount: function () {
    this.repaint();
  },

  repaint: function () {

    var selfDom = Dom.findDOMNode(this);
    var clientHeight = selfDom.clientHeight;
    var clientWidth = selfDom.clientWidth;
    var contentDom = Dom.findDOMNode(this.refs.content);

    var length1 = 59;
    var length2 = 21;
    var barHeight;
    var actualProgress;
    var contentStyle;
    var actualStyle;

    barHeight = (clientHeight * length2) / length1;
    if (this.props.value == 100) {
      actualProgress = clientHeight - barHeight - 13;
    } else {
      actualProgress = (clientHeight - 30 - barHeight) * (this.props.value / 100) + 15;
    };

    contentStyle = {
      position: 'absolute',
      left: '1px',
      top: Math.round(actualProgress - 1) + 'px',
      width: parseInt(clientWidth - 2, 10) + 'px',
      height: Math.round(barHeight) + 'px',
      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
      border: 'none'
    };

    contentDom.style.left = contentStyle.left;
    contentDom.style.top = contentStyle.top;
    contentDom.style.width = contentStyle.width;
    contentDom.style.height = contentStyle.height;
  },

  render: function () {
    var topBarStyle;
    var bottomBarStyle;
    var contentStyle;
    var divStyle;

    divStyle = {
      position: 'absolute',
      //left: this.props.left || '0px',
      top: this.props.top || '0px',
      right: this.props.right || '0px',
      bottom: this.props.bottom || '0px',
      width: this.props.width ? this.props.width + 'px' : '12px',
      height: this.props.height ? this.props.height + 'px' : '100%',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
      backgroundColor: this.props.backgroundColor || GlobalConst.GLOBAL_COLOR.LIGHT_GRAY_COLOR,
      zIndex: this.props.zIndex || undefined
    };

    topBarStyle = {
      position: 'absolute',
      left: '-1px',
      top: '-1px',
      width: this.props.width || '12px',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
    };

    bottomBarStyle = {
      position: 'absolute',
      bottom: '-2px',
      left: '-1px',
      width: this.props.width || '12px',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
    };

    contentStyle = {
      position: 'absolute',
      left: '2px',
      top: '0px',
      width: '0px',
      height: '0px',
      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
      border: 'none'
    };

    return (<div key='scrollBar' style={divStyle}>
      <img style={topBarStyle} src={assetsHelper.getAsset('scrollbar/scrollbar-top.png')}/>
      <img style={bottomBarStyle} src={assetsHelper.getAsset('scrollbar/scrollbar-bottom.png')}/>
      <div ref='content' style={contentStyle}/>
    </div>);
  }
});

module.exports = VerticalScrollBar;



// WEBPACK FOOTER //
// ./src/views/common/VerticalScrollBar.jsx